import { render, staticRenderFns } from "./OffersTraffic.vue?vue&type=template&id=5efb87fd&scoped=true"
import script from "./OffersTraffic.vue?vue&type=script&lang=js"
export * from "./OffersTraffic.vue?vue&type=script&lang=js"
import style0 from "./OffersTraffic.vue?vue&type=style&index=0&id=5efb87fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efb87fd",
  null
  
)

export default component.exports